export const ARTWORKS = {
  droplet: {
    key: "droplet", label: "Droplet", fig: "Droplet city",
    poster: "/art/home/droplet.webp", scene: "/art/home/droplet-scene.webp", cutout: "/art/home/droplet-cutout.webp",
    paper: "#FDFBF3", titleBand: 15,
  },
  seas: {
    key: "seas", label: "Rising Seas", fig: "Rising seas",
    poster: "/art/home/seas.webp", scene: "/art/home/seas-scene.webp", cutout: null,
    paper: "#FDFCF8", titleBand: 17,
  },
};

export const DESIGNS = ["Gallery", "Cinematic", "Bento", "Blueprint", "Ethereal", "Card Table", "Framed", "Sea Band", "Box Lid", "Minimal"];

export const TAGLINE = "You cannot fight water; you need to learn to live with it.";
export const CREDIT = "Designed by Harshat Verma";

export const HOW_TO_PLAY = [
  { title: "Build", text: "Play build cards one at a time — after each, take a card from the Market — take or play an action card, then end your turn." },
  { title: "Absorb", text: "Every round a weather card is drawn: clear skies, rain, heat or a storm surge hits part of the board. Absorption, shading and storm protection nearby cut your repairs." },
  { title: "Rise", text: "Every degree on the carbon meter makes the sea rise and claim low coast. Sea walls hold it back — for a while." },
  { title: "Score", text: "At 3° the most resilience wins; after round 12, the highest population + resilience − debt wins." },
];

// Invisible hit area over the poster's printed title, so the hidden designer trigger still works.
export function PosterTitleHit({ art, onClick }) {
  return <button type="button" aria-label="Porosity" data-testid="home-title" onClick={onClick} className="hl-title-hit" style={{ height: `${art.titleBand}%` }} />;
}

export function stagger(i, base = 0.08) {
  return { animationDelay: `${base + i * 0.07}s` };
}
